import {
  Action,
  HomeState,
  HOME_SET_OPEN_PRODUCT_DROPDOWN,
  HOME_SET_OPEN_PROFILE_DROPDOWN,
  HOME_SET_OPEN_SIDEMENU,
  HOME_SET_SELECTED_DOMAIN,
  HOME_SET_SELECTED_PRODUCT_TYPE,
  HOME_SET_VALID_EMAIL_TYPE,
  HOME_SET_DEBUG,
  HOME_SET_ADMIN_LIST,
} from './types'

export function homeReducer(state: HomeState, action: Action) {
  switch (action.type) {
    case HOME_SET_DEBUG:
      return {
        ...state,
        debug: action.debug,
      }
    case HOME_SET_SELECTED_DOMAIN:
      return {
        ...state,
        selected: {
          ...state.selected,
          domain: action.domain,
        },
      }
    case HOME_SET_SELECTED_PRODUCT_TYPE:
      return {
        ...state,
        selected: {
          ...state.selected,
          productType: action.productType,
        },
      }
    case HOME_SET_OPEN_PRODUCT_DROPDOWN:
      return {
        ...state,
        opened: {
          ...state.opened,
          productDropdown: action.openProductDropdown,
        },
      }
    case HOME_SET_OPEN_PROFILE_DROPDOWN:
      return {
        ...state,
        opened: {
          ...state.opened,
          profileDropdown: action.openProfileDropdown,
        },
      }
    case HOME_SET_OPEN_SIDEMENU:
      return {
        ...state,
        opened: {
          ...state.opened,
          sidemenu: action.openSidemenu,
        },
      }
    case HOME_SET_VALID_EMAIL_TYPE:
      return {
        ...state,
        selected: {
          ...state.selected,
          validEmailType: action.validEmailType,
        },
      }
    case HOME_SET_ADMIN_LIST: {
      return {
        ...state,
        selected: {
          ...state.selected,
          adminList: action.adminList,
        },
      }
    }
    default:
      throw Error('Not Exist Action In homeReducer')
  }
}
